/**
 * 闪送员端js-bridge
 */
import { getOSType } from './utils'
import { tryCatchIssJsBridgeCourier, injectCallBack } from './decorators'
import { IReqParams, IParams } from './interface'
import { EOSType } from '@/utils/IssJsBridgeCourier/consts'
export default class IssJsBridgeCourier {
  constructor (app) {
    app.IssJsBridgeCourier = this
  }

  public static init (ctx) {
    return new IssJsBridgeCourier(ctx)
  }

  /***
   * 关闭h5页面
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public closeWeb () {
    if (getOSType() === EOSType.android) {
      window.IssJsBridgeCourier.closeWeb()
    }
  }

  /**
   * 获取当前位置
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getCurrentLocation (params: IReqParams) { }

  /**
  * ios获取当前历史位置
  */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getValidLocation (params: IReqParams) { }

  /**
   * 打开端外导航
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public startPhoneNavi (params: IParams & IReqParams) { }

  /**
   * 获取路线信息
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getRouteLineInfo (params: IParams & IReqParams) { }

  /**
   * 拨打电话
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public callPhone (params: IReqParams) { }

  /**
   * 联系客服
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public contactCustomer (params: IReqParams) { }

  /**
   * 退出登录
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public logoutToLogin (params: IReqParams) { }

  /**
   * 注销账号
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public cancelAccount (params: IReqParams) { }

  /**
   * 版本升级
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public checkAppVersion (params: IReqParams) { }

  /**
   * 更新用户状态
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public updateUserStatus (params: IParams & IReqParams) { }

  /**
   * 关闭其它页
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public closeOtherPage () {
    if (getOSType() === EOSType.android) {
      window.IssJsBridgeCourier.closeOtherPage()
    }
  }

  /**
   * 淘汰页行为：淘汰页渲染成功后调用
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public eliminateAction (params: IParams & IReqParams) { }

  /**
   * 请求广告
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public requestAD (params: IParams & IReqParams) { }

  /**
   * 请求广告
   * params:String(广告上报事件Url)
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public reportADEvent (params: IParams & IReqParams) { }

  /**
   * 微信支付
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public toWxPay (params: IReqParams) { }

  /**
   * 支付宝支付
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public toAliPay (params: IReqParams) { }

  /**
   * 旧手机号登录
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public cancelIdCardOccupied (params: IReqParams) { }

  /**
   * 找回账号
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public confirmIdCardOccupied (params: IReqParams) { }

  /**
   * 奖励中心热力图
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public toRewardCentersHeatMap (params: IReqParams) { }

  /**
   * 奖励活动热力图
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public toRewardActivityHeatMap (params: IReqParams) { }

  /**
   * 取消订单成功通知Native
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public onCancelOrderSuccess (params: IReqParams) { }

  /**
   * 道具详情数据刷新
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public refreshProp (params: IReqParams) { }

  /**
   * 显示APP加载弹窗
   * params.content 弹窗内容，非必填
   * params.showMaxTimeMillis 弹窗展示最长时间，单位：毫秒，APP默认1分钟,非必填
   * params.cancelable 弹窗是否允许手动取消，APP默认false,非必填
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public showLoadingDialog (params: IParams & IReqParams) { }

  /**
   * 隐藏APP加载弹窗
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public hideLoadingDialog (params: IReqParams) { }

  /**
   * 分享自定义view模板
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public shareCustomViewTemplate (params: IReqParams) { }

  /**
   * 打开支付宝授权
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public toAliAuth (params: IReqParams) { }

  /**
   * 微信分享
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public openShare (params: IReqParams) { }

  /**
   * 发送短信
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public openSms (params: IReqParams) { }

  /**
   * 保存相册
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public savePhotoAlbum (params: IReqParams) { }

  /**
   * 获取经纬度及详细地址
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getRealtimeLocation (params: IReqParams) { }

  /**
     * 添加标题栏右侧文本按钮
     */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public addTextButtonToRightOfTitleBar (params: IReqParams) { }

  /**
     * 添加标题栏右侧文本按钮
     */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public openAppCamera (params: IReqParams) { }

  /**
     * iOS压缩图片
     */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getSingleImgData (params: IReqParams) { }

  /**
     * 打开手机外部浏览器
     */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public openMobileBrowser (params: IReqParams) { }

  /**
     *上报日志
     */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public uploadLogs (params: IReqParams) { }

  /**
     *通过协议获取token
     */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getToken (params: IReqParams) { }

  /**
   *通过协议获取UserName
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getUserName (params: IReqParams) { }

  /**
   *通过协议校验token准确性
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public checkToken (params: IReqParams) { }

  /**
   *更新交通工具
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public updateTransportWayInfo (params: IReqParams) { }

  /**
   *iOS更新城市ID
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public updateCityId (params: IReqParams) { }

  /**
   *选择本地视频文件
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public selectLocalVideo (params: IReqParams) { }

  /**
   *获取App配置信息
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getConfigValue (params: IReqParams) { }

  /**
   *接单设置变更保存成功后触发
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public refreshAutoGrabPreference (params: IReqParams) { }

  /**
   *设置web缓存模式仅Android
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public setWebCache (params: IReqParams) { }

  /**
   * 申诉后通知app刷新页面
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public refreshOrderAppeal (params: IReqParams) { }

  /**
   * 取消单选择位置判断是否位置漂移
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public isCanCancelOrder (params: IReqParams) { }

  /**
   * 取消单选择位置判断是否位置漂移
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getStatusBarHeight (params: IReqParams) { }

  /**
   * 打开web页面
   * 获取闪送员个人信息
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getUserInfo (params: IReqParams) { }

  /**
   * app处理base64编解码
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public base64LinkParams (params: IReqParams) { }

  /**
   * 取消单获取相关信息
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getCancelOrderInfo (params: IReqParams) { }

  /**
   * 打开新的webview
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public openWeb (params: IReqParams) { }

  /**
   *  沉浸式布局
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public updateImmersionBar (params: IReqParams) { }

  /**
   * 新交通工具开关是否开启
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getTrafficSwitch (params: IReqParams) { }

  /**
   * 添加/移除水印
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public showWatermark (params: IReqParams) { }

  /**
   * 活体识别处理机审版本
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public onLiveAuthCheck (params: IReqParams) { }

  /**
   * 招募成功
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public onRecruitSucceed (params: IReqParams) { }

  /**
   * 联系人工客服
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public openArtificialCustomer (params: IReqParams) { }

  /**
   * 自定义titlebar返回按钮事件
   * * @param params
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public goBack (params: IReqParams) { }

  /**
   * 获取强派单重新算路参数
   * * @param params
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public getCheckCancelOrderParam (params: IReqParams) { }

  /**
  * 打开订单详情页
  * * @param params
  */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public openDeliveryPage (params: IReqParams) { }

  /**
   * 打开七鱼AI客服并发送一条消息
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public contactCustomerWithMessage (params: IReqParams) { }

  /**
   * 打开七鱼人工客服并发送一条消息
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public openArtificialCustomerWithMessage (params: IReqParams) { }

  /**
   * 缓存
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public localSaveKV (params: IReqParams) { }

  /**
   * 缓存
   */
  @tryCatchIssJsBridgeCourier()
  @injectCallBack()
  public localGetKV (params: IReqParams) { }
}
